
import React from 'react';
// import PropTypes from 'prop-types';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import { MenuItem } from '@material-ui/core';

const RenderSelectFieldRedux = props => {
  const { label, data, input } = props
  return  <FormControl variant="outlined" style={{minWidth: '100%'}}>
          <InputLabel id="demo-simple-select-outlined-label">{label}</InputLabel>
            <Select
            label={label}
            labelId="demo-simple-select-label"
            {...input}
            // value={selectedAccount}
            >
                {
                    data.map(option => {
                      return <MenuItem key={option.id || option.Codigo || option.Secuencial || option.uuid  } value={option.value || option.Codigo || option.Secuencial}>{`${option.text || option.Nombre || option.name}`}</MenuItem>
                    })
                }
            </Select>
        </FormControl>
}

/* renderSelectField.propTypes = {
     
}; */

export default RenderSelectFieldRedux;